import { useVerifyTokenQuery } from '../features/slice/auth/session-api';

export const useUserVerify = () => {
  const { isError, data, isLoading, isSuccess, refetch } =
    useVerifyTokenQuery('verify-token');

  return {
    isError,
    data,
    isLoading,
    isSuccess,
    refetch,
  };
};
